export const AnalyticParams = {
  UTM_SOURCE: "utm_source",
  UTM_MEDIUM: "utm_medium",
  UTM_CAMPAIGN: "utm_campaign",
  UTM_CONTENT: "utm_content",
  UTM_TERM: "utm_term",

  UTM_SPOT: "utm_spot",
  UTM_SUB_SPOT: "utm_sub_spot",
  UTM_CUSTOM: "utm_custom",
  UTM_ORIGIN: "utm_origin",

  // Should be grabbed from cookies
  FBP: "_fbp",
  FBC: "_fbc",

  PERS_UID: "pers_uid",

  // click id
  FBCLID: "fbclid",
  CLICK_ID: "click_id",
  GCLID: "gclid",

  // ab test
  AB_TEST: "up_ab_test",
} as const;

export const ANALYTIC_PARAMS_ARRAY = Object.values(AnalyticParams);
